"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteBasketUpload = void 0;
/**
 * Delete a basket upload
 */
var deleteBasketUpload = function (instance) {
    return function (token, fileName, config) {
        return instance.delete("/catalogues/baskets/".concat(token, "/").concat(fileName), config);
    };
};
exports.deleteBasketUpload = deleteBasketUpload;
